import React, { Component } from 'react';
import './App.css';

import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {changeWindowWidth, changeWindowHeight} from './redux/ReduxActions/WindowDimensionActions'
import IncreaseValueOverTime from './components/IncreaseValueOverTime/IncreaseValueOverTime.js'
import HomePage from './components/HomePage/HomePage.js'
import FastFiatTransfer from './components/FastFiatTransfer/FastFiatTransfer.js'
import TradeCrypto from './components/TradeCrypto/TradeCrypto.js'
import GetAShare from './components/GetAShare/GetAShare.js'
import RoadMap from './components/RoadMap/RoadMap.js'
import SwiftBanking from './components/SwiftBanking/SwiftBanking.js'
import AdvisorsPartnersTeam from './components/AdvisorsPartnersTeam/AdvisorsPartnersTeam.js'
import Footer from './components/Footer/Footer.js'
import NavBar from "./components/NavBar/NavBar";

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            width: 0,
            height: 0,
            scrollY: 0,
            navBarStyle: 'navbar__main-panel '
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    // Throttle event listeners
    throttle (callback, limit) {
        var tick = false;
        return function () {
            if (!tick) {
                callback.call();
                tick = true;
                setTimeout(function () {
                    tick = false;
                }, limit);
            }
        }
    }

    // Handles showing and hiding NavBar on scroll
    handleScroll() {
        // Check if scroll is up or down
        if (window.scrollY < 1) {
            // Always show nav bar when it is visible
            this.setState({
                scrollY: window.scrollY
            });
        }
        else if (window.scrollY < this.state.scrollY) {
            // Moves NavBar up
            this.setState({
                scrollY: window.scrollY,
                navBarStyle: 'navbar__main-panel navbar__animate-down'
            });
        }
        else if (window.scrollY > this.state.scrollY) {
            // Moves NavBar down
            this.setState({
                scrollY: window.scrollY,
                navBarStyle: 'navbar__main-panel navbar__animate-up'

            });
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        // Add function that listens for scroll
        window.addEventListener('scroll', this.throttle(this.handleScroll, 16));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('scroll', this.handleScroll);
    }

    updateWindowDimensions() {
        this.props.changeWindowWidth(window.innerWidth)
        this.props.changeWindowHeight(window.innerHeight)
    }

    render() {
        return (
            <div className="App">

                <NavBar animate={this.state.navBarStyle} />

                <div style={{height: '80px'}}/>
                <HomePage />
                <FastFiatTransfer />
                <div style={{height: '225px'}} />
                <TradeCrypto />
                <div style={{height: '175px'}} />
                <IncreaseValueOverTime/>
                <div style={{height: (this.props.windowDimensions.windowWidth > 375) ? '225px' : '125px'}} />
                <GetAShare />
                <div style={{height: (this.props.windowDimensions.windowWidth > 375) ? '50px' : '0px'}} />
                <SwiftBanking />
                <RoadMap/>
                <div style={{height: '125px'}} />
                <AdvisorsPartnersTeam/>
                <div style={{height: '125px'}} />
                <Footer />
            </div>
        );
    }
}

const mapStatesToProps = (state) =>{
    return{
        windowDimensions: state.windowDimensions,
    }
}

const mapActionsToProps = (dispatch,props) =>{
    return bindActionCreators({
        changeWindowHeight: changeWindowHeight,
        changeWindowWidth: changeWindowWidth,
    }, dispatch)
}

export default connect(mapStatesToProps, mapActionsToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js